export const Background = () => (
  <>
    <div className="noise" />
    <div className="absolute inset-0 grid-bg pointer-events-none" />
    <div
      className="glow-orb animate-float"
      style={{
        width: 520,
        height: 520,
        background: "rgba(168, 85, 247, 0.18)",
        top: "-160px",
        left: "-120px",
      }}
    />
    <div
      className="glow-orb animate-float"
      style={{
        width: 600,
        height: 600,
        background: "rgba(124, 58, 237, 0.12)",
        bottom: "-200px",
        right: "-160px",
        animationDelay: "2s",
      }}
    />
  </>
);
